import React from 'react';

type ProspType = {
    style?: any,
    children: any,
};

const Row = ({ style = {}, children }: ProspType) => (
    <div style={{ display: 'flex', flexDirection: 'row', ...style }}>
        {children}
    </div>
);

export default Row;